import React from "react";
import { Button, Space } from "antd";
import { useAtom } from "jotai";
import {
	visibleModalCrearSolicitudAusenciaAtom,
	visibleModalRecordVacacionalAtom,
} from "pages/vacaciones/componentes/common/mis-solicitudes/store/MisSolicitudesStore";
import LoginService from "services/LoginService";

const BotonesMisSolicitudes = () => {
	const [, setVisibleModal] = useAtom(visibleModalCrearSolicitudAusenciaAtom);
	const [, setVisibleModalRecordVacacional] = useAtom(visibleModalRecordVacacionalAtom);
	const isSDF = LoginService.getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;
	const isSDFEnergia = LoginService.getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;
	const isManuelita = LoginService.getUsuarioAutenticado().empresaSeleccionada?.ruc === "20411051782" ? true : false;
	const isPSP = LoginService.getUsuarioAutenticado().empresaSeleccionada?.ruc === "20601257280";

	return (
		<div style={{ textAlign: "right" }}>
			<Space>
				<Button onClick={() => setVisibleModalRecordVacacional(true)}>Vacaciones Disponibles</Button>
				{!isPSP && (
					<Button type="primary" onClick={() => setVisibleModal(true)}>
						{(isSDF || isSDFEnergia || isManuelita) ? "Solicitar Movimiento" : "Solicitar Ausencia"}
					</Button>
				)}
			</Space>
		</div>
	);
};

export default BotonesMisSolicitudes;
